import { I_AP_CATEGORY_ID_ENUM, type IAnnualProgram } from '../../../../types/annual-programs'

import { editorJsBlocksToHtml } from './editorjs-to-html'

import type {
	IProgram,
	IProgramItem,
	ProgramColor
} from '../../../../components/program-card/_types/types'
import type { IBenefit } from '../../../../types/benefit'
import type { IProgramModule } from '../../../../types/module'

const CATEGORY_TO_COLOR: Record<number, ProgramColor> = {
	[I_AP_CATEGORY_ID_ENUM.MALE]: 'blue',
	[I_AP_CATEGORY_ID_ENUM.FEMALE]: 'cyclamen',
	[I_AP_CATEGORY_ID_ENUM.FAMILY]: 'purple',
	[I_AP_CATEGORY_ID_ENUM.CHILD]: 'sand'
}

const DEFAULT_COLOR: ProgramColor = 'cyclamen'

/**
 * Converts a single IAnnualProgram to IProgram for MProgramCard.
 */
export function convertAnnualProgramToProgram(annual: IAnnualProgram): IProgram {
	const items: IProgramItem[] = (annual.benefits ?? [])
		.slice()
		.sort((a: IBenefit, b: IBenefit) => a.sortOrder - b.sortOrder)
		.map((b: IBenefit) => ({
			icon: b.icon,
			title: b.name,
			content: editorJsBlocksToHtml(b.description),
			sortOrder: b.sortOrder
		}))

	// Modules are passed through as-is (keeping EditorJS OutputData format for description)
	const modules = (annual.modules ?? []) as IProgramModule[]

	const color = CATEGORY_TO_COLOR[annual.categoryId] ?? DEFAULT_COLOR

	return {
		id: annual.id,
		title: annual.name,
		subtitle: annual.cardHeaderDescription ?? undefined,
		price: annual.price,
		oldPrice: annual.priceOld > 0 ? annual.priceOld : undefined,
		featured: annual.isFeatured,
		expanded: annual.isExpanded,
		url: annual.url,
		orderUrl: `/volne-terminy?type=annual-program&id=${annual.id}`,
		items,
		modules,
		color
	}
}
